import { CartPlusIcon } from './CartPlusIcon';

/**
 * author: Google
 * id 2BF13245-A7BF-49EC-8EB0-CA10F7AF11B2
 * name cart-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-plus.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartAddIcon = CartPlusIcon;
export default ShoppingCartAddIcon